const yodaFormatter = ({ id: iri, attributes, ...object }) => ({
  ...object,
  ...attributes,
  iri,
})

export default yodaFormatter
